import { S } from '../strings';
import { Logo } from '../ui/Logo';

/** Anyone who opens the address directly, outside the Lagos Life frame. */
export function Outside() {
  return (
    <main className="screen center">
      <Logo />
      <section className="card">
        <h2 className="display small">{S.outside.title}</h2>
        <p>{S.outside.body}</p>
      </section>
    </main>
  );
}
